const getCookieDomain = (hostname: string): string => {
  const parts = hostname.split(".");
  if (parts.length > 2) {
    parts.shift();
  }
  return `.${parts.join(".")}`;
};
export default getCookieDomain;
